module.exports = __webpack_public_path__ + "static/img/representative-s.1511ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/representative-s.png
// module id = 8Tox
// module chunks = 1